import { useState } from "react";
import { useNavigate } from "react-router";
import { Button } from "@/components/ui";
import { useLogout } from "@/lib/session";
import { SwitchToParentSheet } from "@/components/SwitchUser";

/** Shown to kids when their family's plan isn't active, or a parent hasn't given consent. */
export function KidLocked({ reason = "plan" }: { reason?: "plan" | "consent" }) {
  const logout = useLogout();
  const navigate = useNavigate();
  const [toParent, setToParent] = useState(false);
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-4 bg-canvas px-6 text-center">
      <span className="text-6xl" aria-hidden>
        {reason === "plan" ? "⏸️" : "🔐"}
      </span>
      <h1 className="text-2xl font-black">{reason === "plan" ? "Your family's plan is paused" : "A parent needs to say OK first"}</h1>
      <p className="max-w-sm text-muted">
        {reason === "plan"
          ? "Ask a parent to open Meaningful Rewards on their phone and pick a plan. All your coins and goals are safe."
          : "Ask a parent to open Meaningful Rewards and give permission for you to use it. All your coins and goals are safe."}
      </p>
      <Button
        variant="secondary"
        onClick={async () => {
          await logout();
          navigate("/kid-login", { replace: true });
        }}
      >
        Switch kid
      </Button>
      <Button variant="ghost" onClick={() => setToParent(true)}>
        Back to parent
      </Button>
      <SwitchToParentSheet open={toParent} onClose={() => setToParent(false)} />
    </div>
  );
}
